var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterViewInit, ChangeDetectorRef, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { NavigableComponent } from '../../model/navigable-component';
import { NavigationService } from '../../services/navigation/navigation.service';
import { PageNames } from '../../shared/page-names.enum';
import { OmapiIdConstants } from '../../shared/omapi-id-constants';
import { OrderingModalManagerComponent } from '../../modals/ordering-modals/ordering-modal-manager/ordering-modal-manager.component';
import { DtvCatalogUtils } from '../../utils/dtv-catalog/dtv-catalog.utils';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { TvShopStateService } from '../../services/state/tv-shop-state.service';
var RtlSeriesDetailsComponent = /** @class */ (function (_super) {
    __extends(RtlSeriesDetailsComponent, _super);
    function RtlSeriesDetailsComponent(navigationService, changeDetector, stateService, analyticsService) {
        var _this = _super.call(this, navigationService) || this;
        _this.navigationService = navigationService;
        _this.changeDetector = changeDetector;
        _this.stateService = stateService;
        _this.analyticsService = analyticsService;
        return _this;
    }
    RtlSeriesDetailsComponent.prototype.ngOnInit = function () {
        this.navigationService.setCurrentPageComponent(PageNames.DETAIL_PAGE_INTRO);
        var packs = this.stateService.selectSnapshot(function (state) { return state.tvShopEntertainmentPacks; });
        this.pack = DtvCatalogUtils.getTvShopEntertainmentPackForOmapiId(packs, OmapiIdConstants.RTL_SERIES);
        this.analyticsService.onDetailPage([OmapiIdConstants.RTL_SERIES]);
    };
    RtlSeriesDetailsComponent.prototype.ngOnDestroy = function () {
        this.navigationService.clearNavigation();
    };
    RtlSeriesDetailsComponent.prototype.ngAfterViewInit = function () {
        this.navigationService.resetNavigation();
        this.changeDetector.detectChanges();
        this.navigationService.registerPageElement(this.productDetailContentElement);
    };
    RtlSeriesDetailsComponent.prototype.openOrderModal = function (event) {
        this.order = event;
        this.orderingModal.openModal();
    };
    return RtlSeriesDetailsComponent;
}(NavigableComponent));
export { RtlSeriesDetailsComponent };
